import { render, staticRenderFns } from "./CreateClass.vue?vue&type=template&id=96117eec&scoped=true&"
import script from "./CreateClass.vue?vue&type=script&lang=js&"
export * from "./CreateClass.vue?vue&type=script&lang=js&"
import style0 from "./CreateClass.vue?vue&type=style&index=0&id=96117eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96117eec",
  null
  
)

export default component.exports